module.exports = __webpack_public_path__ + "static/media/Willie Person Mangum - 1836.73258216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Willie Person Mangum - 1836.jpg
// module id = 577
// module chunks = 0